import { Field } from 'react-final-form';

import TextField from 'components/Inputs/FormInputs/TextField';
import { required } from 'utilities/validators';

interface MeetingSpaceRequirementsProps {
  showFields: boolean;
}

const MeetingSpaceRequirements = ({
  showFields,
}: MeetingSpaceRequirementsProps) => {
  if (!showFields) {
    return null;
  }

  return (
    <div className="ml-0 mt-4 space-y-4 border-l-4 border-accentGreen pl-6 lg:ml-[50%]">
      <h4 className="font-arimo text-sm font-medium text-gray-900">
        Please provide the following meeting space details:
      </h4>

      <div>
        <Field
          name="meetingSpaceRequirements.squareFootage"
          type="text"
          label="Square Footage"
          placeholder="Enter required square footage (sq ft)"
          component={TextField}
          validate={required}
        />
      </div>

      <div>
        <Field
          name="meetingSpaceRequirements.avRequirements"
          type="text"
          label="AV Requirements"
          placeholder="Enter AV requirements"
          component={TextField}
          validate={required}
        />
      </div>

      <div>
        <Field
          name="meetingSpaceRequirements.setupDetails"
          multiline={true}
          label="Meeting Space Details"
          placeholder="Enter additional details about the meeting space"
          component={TextField}
          rows={4}
          className="block min-h-[100px] w-full rounded-md border-gray-300 text-sm shadow-sm"
        />
      </div>
    </div>
  );
};

export default MeetingSpaceRequirements;
